import { apiFetch } from "../utils/apiFetch"

export type DesignSearchResultItem = {
  designNumber: string
  applicationNumber?: string
  applicationDate?: string
}

export type DesignDetails = {
  designNumber: string
  applicationNumber: string
  applicationDate: string
}

export function searchDesigns(designNumber: string) {
  const query = new URLSearchParams({ designNumber })

  return apiFetch(
    `/api/euipo/design-search/designs?${query.toString()}`
  ) as Promise<DesignSearchResultItem[]>
}

export function getDesignDetails(designNumber: string) {
  return apiFetch(
    `/api/euipo/design-search/designs/${encodeURIComponent(designNumber)}`
  ) as Promise<DesignDetails>
}
